module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reporting"
  }, [_c('a', {
    staticClass: "d-back-link",
    attrs: {
      "href": "/calendar"
    }
  }, [_vm._v("Tilbage til Docendo")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "d-tabs"
  }, _vm._l((_vm.theTabs), function(tab, prop) {
    return _c('div', {
      staticClass: "d-tabs__tab",
      class: [{
          'd__tabs__tab--inactive': tab.inactive
        },
        {
          'd-tabs__tab--active': _vm.getIsTheActiveTab(prop)
        }
      ],
      on: {
        "click": function($event) {
          return _vm.setTheActiveTab(tab, prop)
        }
      }
    }, [_vm._v("\n      " + _vm._s(prop) + ". " + _vm._s(tab.title) + "\n    ")])
  }), 0), _vm._v(" "), (_vm.isLoadingStilData) ? _c('div', {
    staticStyle: {
      "width": "500px"
    }
  }, [_c('Loader')], 1) : _c('div', {
    staticClass: "reporting-content"
  }, [_c('div', {
    staticClass: "reporting__table"
  }, [_c(_vm.theActiveComponent, {
    tag: "component",
    attrs: {
      "standardSubjects": _vm.standardSubjects,
      "stilData": _vm.stilData,
      "dbStilData": _vm.dbStilData,
      "isShowSubjects": _vm.isShowSubjects,
      "usersSSNHash": _vm.usersSSNHash,
      "klokketimetyper": _vm.klokketimetyper
    },
    on: {
      "updateStil": _vm.updateStil,
      "updateStilReportUser": _vm.updateStilReportUser
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reporting__header"
  }, [_c('div', {
    staticClass: "reporting__header__right"
  }, [_c('h1', [_vm._v("Kompetenceindberetning")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f10a4072!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reporting/KompetenceIndberetning/KompetenceIndberetning.vue
// module id = 2160
// module chunks = 1